import React, { useCallback, useContext, useState } from 'react'
import { useForm } from 'react-hook-form'
import { AuthContext } from './authProvider'
import { setUserCookies } from './authService'
import { Form, InputGroup, Spinner } from 'react-bootstrap'
import img from '../../assets/img/brand/explore-w-logo-blue-large@2x.png'

const EMAIL_ERROR_TYPES = {
  required: 'This field is required!',
  pattern: 'The provided email is not valid!'
}

const PASSWORD_ERROR_TYPES = {
  required: 'This field is required!',
  minLength: 'Password should be at least 6 characters long!'
}

export function SignIn() {
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    reset
  } = useForm()

  const authContext = useContext(AuthContext)
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

  const [isLoading, setIsLoading] = useState(false)
  const [unauthorized, setUnauthorized] = useState(false)
  const [passwordVisible, setPasswordVisible] = useState(false)

  const onSubmit = useCallback(async () => {
    const { email, password } = getValues()
    setIsLoading(true)

    try {
      const res = await authContext.login(email, password)
      setUserCookies(res)
      setIsLoading(false)

      if (res) {
        window.location.replace('/')
      }
    } catch (error) {
      reset()
      setIsLoading(false)
      setUnauthorized(true)
      console.log(`Error when trying to log in - ${error}`)
    }
  }, [getValues, authContext])

  return (
    <div
      id="login-form-container"
      className="d-flex justify-content-center align-items-center h-50 p-4"
    >
      <form id="login-form" onSubmit={handleSubmit(onSubmit)}>
        <div className="header-logo-container">
          <img className="header-logo" alt="Logo" src={img} />
        </div>
        <div>
          <InputGroup className="mb-3">
            <Form.Control
              className="rounded-lg"
              type="email"
              {...register('email', { required: true, pattern: emailRegex })}
              placeholder="Email"
              aria-label="Email"
              aria-describedby="basic-addon1"
            />
          </InputGroup>
        </div>
        {errors.email && (
          <div className="error-message">
            {EMAIL_ERROR_TYPES[errors.email.type]}
          </div>
        )}
        <InputGroup className="mb-3 flex items-center justify-content-center">
          <Form.Control
            className="rounded-lg h-auto"
            type={passwordVisible ? 'text' : 'password'}
            {...register('password', { required: true, minLength: 6 })}
            placeholder="Password"
            aria-label="Password"
            aria-describedby="basic-addon1"
          />
          <InputGroup.Text
            onClick={() => setPasswordVisible(!passwordVisible)}
            className="visibility-icon-container"
          >
            <span className="material-icons visibility-icon">
              {passwordVisible ? 'visibility_off' : 'visibility'}
            </span>
          </InputGroup.Text>
        </InputGroup>
        {errors.password && (
          <div className="error-message">
            {PASSWORD_ERROR_TYPES[errors.password.type]}
          </div>
        )}
        {unauthorized && (
          <div className="error-message unauthorized">
            Your password is incorrect or this account doesn't exist.
          </div>
        )}
        <div className="sign-in-button-container">
          <button className="btn btn-primary" id="signin-button" type="submit">
            {isLoading ? <Spinner size="sm" animation="border" /> : 'Sign In'}
          </button>
        </div>
        <div className="sign-up-container">
          <p>Don't have an account?</p>
          <a
            className="sign-up-button"
            href="https://accounts.imray.com/account/register"
          >
            <p>Sign Up</p>
          </a>
        </div>
      </form>
    </div>
  )
}
